import { _ } from "~/common/Utils";

const fetchJson = (url) => {
    return new Promise((resolve) => {
        _.Platform.Native().Get({
            url,
            headers: {
                'pragma': 'no-cache',
                'cache-control': 'no-cache'
            }
        }).Done(({ response }) => {
            resolve(response);
        }).Fail(({ error = {} } = {}) => {
            if (_.Navigation.IsOnline() && _.Connection.IsOnline()) {
                _.Log.Error({
                    message: `Fetch failed for ${url}. Error: ${error.message}`
                });
            }

            resolve(null);
        });
    });
};

const RequestModule = {
    fetchJson
};

export default RequestModule;